import tw from 'tailwind-styled-components'
import {getRing, RingColor, RingSize} from '@components/common/base/common/ring'
import {cn} from '@containers/html-utils'
import {StatusSize} from './types'
import {getBackground, getSize} from './utils'

export const TwUserStatus = tw.div<{
  $size: StatusSize
  $hideOutline?: boolean
  $outlineSize: RingSize
  $outlineColor: RingColor
  $online: boolean
  $doNotDisturb: boolean
}>`
  rounded-full
  ${p =>
    cn(
      getSize(p.$size),
      !p.$hideOutline &&
        (p.$online || p.$doNotDisturb) &&
        getRing(p.$outlineSize, p.$outlineColor),
      getBackground(p.$online, p.$doNotDisturb)
    )}
`
